import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component PuzzleIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <PuzzleIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <PuzzleIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const PuzzleIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="PuzzleIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 3A3.5 3.5 0 0115 6.5h1.5a2 2 0 012 2V10a3.5 3.5 0 013.5 3.5l-.004.174A3.5 3.5 0 0118.5 17v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-4.023h2a1.476 1.476 0 001.47-1.332l.007-.145A1.476 1.476 0 006 12.023H4V8.5a2 2 0 012-2h2a3.5 3.5 0 01.905-2.349l.12-.126A3.5 3.5 0 0111.5 3zm0 2.023A1.476 1.476 0 0010.023 6.5v2H6V10a3.5 3.5 0 013.5 3.5l-.004.174A3.5 3.5 0 016 17v2h10.5l.014-4.023H18.5a1.476 1.476 0 001.47-1.332l.007-.145a1.476 1.476 0 00-1.477-1.477h.16-2.146L16.5 8.5h-3.523v-2A1.476 1.476 0 0011.5 5.023z"
      />
    </svg>
  )
);
PuzzleIcon.displayName = "PuzzleIcon";
export default PuzzleIcon;
